/**
 * sgokit's `@kevlarcon/formkit` client. The package's `makeRestFormKitClient`
 * implements the whole `FormBuilderClient` interface against `formkit.urls`'
 * own stock REST surface (mounted in `sgokit/urls.py` via
 * `include('formkit.urls')`) — sgokit only supplies its pre-configured axios
 * instance. The `uploads` adapter is django-uploads' generic presign endpoint
 * (`api/uploads/presign/`, categories registered in accounts/uploads.py): it
 * backs the `image` field's drag-and-drop widget. The other presign-dependent
 * methods (CSV field bootstrap, dataset file import) name categories sgokit
 * hasn't registered, so they'd be refused server-side; everything else,
 * including the design-time CRUD the form builder needs, works as-is.
 */
import { makeRestFormKitClient } from '@kevlarcon/formkit';
import { uploadFileDirect } from '@kevlarcon/pages';
import apiClient from './client';

export const formKitClient = makeRestFormKitClient(apiClient, {
  uploads: {
    presign: (filename, category) =>
      apiClient.post('uploads/presign/', { category, filename }).then((res) => res.data),
    uploadToS3: uploadFileDirect,
  },
});
